const MIME_TO_EXT: Record<string, string> = {
  'application/pdf': '.pdf',
  'image/jpeg': '.jpg',
  'image/png': '.png',
};

export function mimeTypeToExtension(mimeType: string): string {
  return MIME_TO_EXT[mimeType] ?? '.pdf';
}
